import { createSlice } from '@reduxjs/toolkit';

export const surveySlice = createSlice({
    name: 'survey',
    initialState: {
        loading: false,
        surveyProcessResponse: null,
        errorsResponse: null,
    },
    reducers: {
        initSaveSurveyProcess: state => {
            state.loading = true;
        },
        saveSurveyProcess: (state) => {
            state.loading = false;
            state.surveyProcessResponse = true;
            state.errorsResponse = null;
        },
        saveSurveyProcessError: (state) => {
            state.loading = false;
            state.surveyProcessResponse = false;
            state.errorsResponse = 'Hubo un error';
        },
    }
});

export const { initSaveSurveyProcess, saveSurveyProcess, saveSurveyProcessError } = surveySlice.actions;